import { CoralogixRum } from '@coralogix/browser';

import { useClient } from '@sternum/web/features/client/hooks';
import { trpc, TRPCReactQueryOptions, TRPCRouterOutputs } from '@sternum/web/services/trpc';

import { useSelectedClientId } from '../useSelectedClientId';

export type UseMeResponse = TRPCRouterOutputs['auth']['me'];
export type UseMeOptions = TRPCReactQueryOptions['auth']['me'];

export function useMe(options?: UseMeOptions) {
  const selectedClientId = useSelectedClientId();

  const { data, ...rest } = trpc.auth.me.useQuery(undefined, {
    staleTime: Infinity,
    ...options,
  });

  const { client } = useClient(selectedClientId!, { enabled: !!selectedClientId, staleTime: Infinity });

  const currentUser = data ? { ...data, fullName: `${data.firstName} ${data.secondName}` } : undefined;

  if (currentUser && client && CoralogixRum.isInited) {
    CoralogixRum.setUserContext({
      user_id: currentUser.id,
      user_name: currentUser.fullName,
      user_email: currentUser.email,
      user_metadata: {
        client_id: client.id,
        client_name: client.name,
        role: currentUser.role,
      },
    });
  }

  return {
    currentUser,
    currentClient: client,
    ...rest,
  };
}
